const sgpArr = [
  {
    link: "https://www.pelago.co/en-IN/activity/pziq8-lee-kuan-yew-the-experience-ticket-singapore/",
    image: require("./img/sgp/sgp1.webp"),
    title: "LKY: The Experience",
    price: 1098,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pxelg-rws-sea-aquarium-ticket-singapore/",
    image: require("./img/sgp/sgp2.webp"),
    title: "S.E.A.Aquarium Tickets",
    price: 2623,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pujv8-kiztopia-singapore-singapore/",
    image: require("./img/sgp/sgp3.webp"),
    title: "Kiztopia Marina Square Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p0zni-gardens-by-the-bay-singapore/",
    image: require("./img/sgp/sgp4.webp"),
    title: "Universal Studios Singapore - Halloween Horror Nights 11",
    price: 4819,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pok40-rws-universal-studios-ticket-singapore/",
    image: require("./img/sgp/sgp5.webp"),
    title: "Gardens by the Bay Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pd9kt-universal-studios-singapore--halloween-horror-nights-11-singapore/",
    image: require("./img/sgp/sgp6.webp"),
    title: "Gardens by the Bay Tickets",
    price: 1464,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p4ikn-artscience-museum-singapore/",
    image: require("./img/sgp/sgp7.webp"),
    title: "Singapore Flyer Tickets",
    price: 2440,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pun4o-night-safari-wildlife-park-singapore/",
    image: require("./img/sgp/sgp8.webp"),
    title: "Singapore Flyer Tickets",
    price: 3020,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pb0bw-singapore-river-cruise-singapore/",
    image: require("./img/sgp/sgp9.webp"),
    title: "T-Play Khatib",
    price: 1110,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/ptp1m-bird-paradise-tickets-singapore/",
    image: require("./img/sgp/sgp10.webp"),
    title: "River Wonders Tickets",
    price: 366,
  },
];

const bali = [
  {
    link: "https://www.pelago.co/en-IN/activity/pziq8-lee-kuan-yew-the-experience-ticket-singapore/",
    image: require("./img/bali/bali1.webp"),
    title: "LKY: The Experience",
    price: 1098,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pxelg-rws-sea-aquarium-ticket-singapore/",
    image: require("./img/bali/bali2.webp"),
    title: "S.E.A.Aquarium Tickets",
    price: 2623,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pujv8-kiztopia-singapore-singapore/",
    image: require("./img/bali/bali3.webp"),
    title: "Kiztopia Marina Square Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p0zni-gardens-by-the-bay-singapore/",
    image: require("./img/bali/bali4.webp"),
    title: "Universal Studios Singapore - Halloween Horror Nights 11",
    price: 4819,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pok40-rws-universal-studios-ticket-singapore/",
    image: require("./img/bali/bali5.webp"),
    title: "Gardens by the Bay Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pd9kt-universal-studios-singapore--halloween-horror-nights-11-singapore/",
    image: require("./img/bali/bali6.webp"),
    title: "Gardens by the Bay Tickets",
    price: 1464,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p4ikn-artscience-museum-singapore/",
    image: require("./img/bali/bali7.webp"),
    title: "Singapore Flyer Tickets",
    price: 2440,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pun4o-night-safari-wildlife-park-singapore/",
    image: require("./img/bali/bali8.webp"),
    title: "Singapore Flyer Tickets",
    price: 3020,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pb0bw-singapore-river-cruise-singapore/",
    image: require("./img/bali/bali9.webp"),
    title: "T-Play Khatib",
    price: 1110,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/ptp1m-bird-paradise-tickets-singapore/",
    image: require("./img/bali/bali10.webp"),
    title: "River Wonders Tickets",
    price: 366,
  },
];

const taipei = [
  {
    link: "https://www.pelago.co/en-IN/activity/pziq8-lee-kuan-yew-the-experience-ticket-singapore/",
    image: require("./img/tpi/tpi1.png"),
    title: "LKY: The Experience",
    price: 1098,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pxelg-rws-sea-aquarium-ticket-singapore/",
    image: require("./img/tpi/tpi2.webp"),
    title: "S.E.A.Aquarium Tickets",
    price: 2623,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pujv8-kiztopia-singapore-singapore/",
    image: require("./img/tpi/tpi3.webp"),
    title: "Kiztopia Marina Square Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p0zni-gardens-by-the-bay-singapore/",
    image: require("./img/tpi/tpi4.webp"),
    title: "Universal Studios Singapore - Halloween Horror Nights 11",
    price: 4819,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pok40-rws-universal-studios-ticket-singapore/",
    image: require("./img/tpi/tpi5.webp"),
    title: "Gardens by the Bay Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pd9kt-universal-studios-singapore--halloween-horror-nights-11-singapore/",
    image: require("./img/tpi/tpi6.webp"),
    title: "Gardens by the Bay Tickets",
    price: 1464,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p4ikn-artscience-museum-singapore/",
    image: require("./img/tpi/tpi7.png"),
    title: "Singapore Flyer Tickets",
    price: 2440,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pun4o-night-safari-wildlife-park-singapore/",
    image: require("./img/tpi/tpi8.webp"),
    title: "Singapore Flyer Tickets",
    price: 3020,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pb0bw-singapore-river-cruise-singapore/",
    image: require("./img/tpi/tpi9.webp"),
    title: "T-Play Khatib",
    price: 1110,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/ptp1m-bird-paradise-tickets-singapore/",
    image: require("./img/tpi/tpi10.png"),
    title: "River Wonders Tickets",
    price: 366,
  },
];

const tokyo = [
  {
    link: "https://www.pelago.co/en-IN/activity/pziq8-lee-kuan-yew-the-experience-ticket-singapore/",
    image: require("./img/tky/tky1.webp"),
    title: "LKY: The Experience",
    price: 1098,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pxelg-rws-sea-aquarium-ticket-singapore/",
    image: require("./img/tky/tky2.png"),
    title: "S.E.A.Aquarium Tickets",
    price: 2623,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pujv8-kiztopia-singapore-singapore/",
    image: require("./img/tky/tky3.webp"),
    title: "Kiztopia Marina Square Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p0zni-gardens-by-the-bay-singapore/",
    image: require("./img/tky/tky4.webp"),
    title: "Universal Studios Singapore - Halloween Horror Nights 11",
    price: 4819,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pok40-rws-universal-studios-ticket-singapore/",
    image: require("./img/tky/tky5.webp"),
    title: "Gardens by the Bay Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pd9kt-universal-studios-singapore--halloween-horror-nights-11-singapore/",
    image: require("./img/tky/tky6.png"),
    title: "Gardens by the Bay Tickets",
    price: 1464,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p4ikn-artscience-museum-singapore/",
    image: require("./img/tky/tky7.webp"),
    title: "Singapore Flyer Tickets",
    price: 2440,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pun4o-night-safari-wildlife-park-singapore/",
    image: require("./img/tky/tky8.webp"),
    title: "Singapore Flyer Tickets",
    price: 3020,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pb0bw-singapore-river-cruise-singapore/",
    image: require("./img/tky/tky9.webp"),
    title: "T-Play Khatib",
    price: 1110,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/ptp1m-bird-paradise-tickets-singapore/",
    image: require("./img/tky/tky10.webp"),
    title: "River Wonders Tickets",
    price: 366,
  },
];

const bangkok = [
  {
    link: "https://www.pelago.co/en-IN/activity/pziq8-lee-kuan-yew-the-experience-ticket-singapore/",
    image: require("./img/bgk/bgk1.webp"),
    title: "LKY: The Experience",
    price: 1098,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pxelg-rws-sea-aquarium-ticket-singapore/",
    image: require("./img/bgk/bgk2.jpg"),
    title: "S.E.A.Aquarium Tickets",
    price: 2623,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pujv8-kiztopia-singapore-singapore/",
    image: require("./img/bgk/bgk3.webp"),
    title: "Kiztopia Marina Square Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p0zni-gardens-by-the-bay-singapore/",
    image: require("./img/bgk/bgk4.webp"),
    title: "Universal Studios Singapore - Halloween Horror Nights 11",
    price: 4819,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pok40-rws-universal-studios-ticket-singapore/",
    image: require("./img/bgk/bgk5.webp"),
    title: "Gardens by the Bay Tickets",
    price: 732,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pd9kt-universal-studios-singapore--halloween-horror-nights-11-singapore/",
    image: require("./img/bgk/bgk6.webp"),
    title: "Gardens by the Bay Tickets",
    price: 1464,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/p4ikn-artscience-museum-singapore/",
    image: require("./img/bgk/bgk7.webp"),
    title: "Singapore Flyer Tickets",
    price: 2440,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pun4o-night-safari-wildlife-park-singapore/",
    image: require("./img/bgk/bgk8.webp"),
    title: "Singapore Flyer Tickets",
    price: 3020,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/pb0bw-singapore-river-cruise-singapore/",
    image: require("./img/bgk/bgk9.webp"),
    title: "T-Play Khatib",
    price: 1110,
  },
  {
    link: "https://www.pelago.co/en-IN/activity/ptp1m-bird-paradise-tickets-singapore/",
    image: require("./img/bgk/bgk10.webp"),
    title: "River Wonders Tickets",
    price: 366,
  },
];

// Explore destination data
const exploreArr = [
  { img: require("./img/exp/exp1.jpg"), title: "Singapore" },
  { img: require("./img/exp/exp2.jpg"), title: "Bali" },
  { img: require("./img/exp/exp3.jpg"), title: "Bangkok" },
  { img: require("./img/exp/exp4.jpg"), title: "Taipei" },
  { img: require("./img/exp/exp5.jpg"), title: "Tokyo" },
  { img: require("./img/exp/exp6.jpg"), title: "Osaka" },
];

// Customer Review data
const comments = [
	{
	  message:"It was a very good experience for my friends and I. Especially our travel consultant, Velvet, who took care of us...",
	  visit:"2-Day Sapa Tour to Fansipan Peak and Ethnic..."
	},
	{
	  message:"I booked this for my sons who were visiting us from London. They loved it saying it was the best part of their visit to Singapore...",
	  visit:"Vintage Vespa Sidecar Tour in Singapore City"
	},
	{
	  message:"The Driver was so Patient and waited for me for 50mins, on our way he recommended so much place to visit and...",
	  visit:"Bali Ngurah Rai Airport Transfers by BaliWow"
	},
];

export { sgpArr, bali, taipei, tokyo, bangkok, exploreArr, comments };
